<template>
  <page-header-wrapper>
    <div class="erp-list-page baidao-list-page">
      <div class="erp-search-card">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="8" :sm="24">
              <a-form-item label="关键字">
                <a-input v-model="query.keyword" allow-clear placeholder="签收单号 / 配送任务 / 收货方" @pressEnter="search" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="query.status" allow-clear placeholder="全部">
                  <a-select-option value="pending">待签收</a-select-option>
                  <a-select-option value="signed">已签收</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="24" class="erp-search-actions">
              <a-button type="primary" icon="search" @click="search">查询</a-button>
              <a-button icon="redo" @click="reset">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="erp-table-card">
        <div class="erp-table-toolbar">
          <div>
            <h3>配送签收</h3>
            <p>线路派车单确认发车后生成。配送数量 = 正常签收 + 拒收 + 破损 + 短少。</p>
          </div>
        </div>
        <a-table
          row-key="id"
          :columns="columns"
          :data-source="rows"
          :loading="loading"
          :pagination="pagination"
          bordered
          size="middle"
          :scroll="{ x: 1500 }"
          @change="onTableChange"
        >
          <template slot="signNo" slot-scope="text, record"><a @click="openDetail(record, false)">{{ text }}</a></template>
          <template slot="qty" slot-scope="text">{{ qtyText(text) }}</template>
          <template slot="time" slot-scope="text">{{ text || '—' }}</template>
          <template slot="operation" slot-scope="text, record">
            <a @click="openDetail(record, false)">查看详情</a>
            <template v-if="record.status === 'pending'">
              <a-divider type="vertical" />
              <a @click="openDetail(record, true)">配送签收</a>
            </template>
          </template>
        </a-table>
      </div>
    </div>
    <a-drawer :title="editing ? '配送签收' : '签收详情'" :visible="visible" width="980" @close="visible = false">
      <template v-if="detail">
        <a-descriptions bordered size="small" :column="3">
          <a-descriptions-item label="签收单号">{{ detail.signNo }}</a-descriptions-item>
          <a-descriptions-item label="状态">{{ detail.statusName }}</a-descriptions-item>
          <a-descriptions-item label="配送任务">{{ detail.taskNo }}</a-descriptions-item>
          <a-descriptions-item label="发货单号">{{ detail.shipNo }}</a-descriptions-item>
          <a-descriptions-item label="来源类型">{{ detail.sourceTypeName }}</a-descriptions-item>
          <a-descriptions-item label="收货方">{{ detail.receiverName }}</a-descriptions-item>
          <a-descriptions-item label="收货地址" :span="2">{{ detail.receiverAddress }}</a-descriptions-item>
          <a-descriptions-item label="联系人">{{ detail.contactName || '—' }}</a-descriptions-item>
          <a-descriptions-item label="联系电话">{{ detail.contactPhone || '—' }}</a-descriptions-item>
          <a-descriptions-item label="签收人">
            <a-input v-if="editing" v-model="signerName" placeholder="请输入签收人" />
            <span v-else>{{ detail.signerName || '—' }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="签收时间">{{ detail.signTime || '—' }}</a-descriptions-item>
        </a-descriptions>
        <h4 style="margin:16px 0 8px">商品签收明细</h4>
        <a-table row-key="id" size="small" bordered :pagination="false" :data-source="detail.items" :columns="editing ? editColumns : viewColumns" :scroll="{ x: 980 }">
          <template slot="qty" slot-scope="text">{{ qtyText(text) }}</template>
          <template slot="ok" slot-scope="text, record"><a-input-number v-model="record.qtyOk" :min="0" :precision="3" style="width:100%" /></template>
          <template slot="reject" slot-scope="text, record"><a-input-number v-model="record.qtyReject" :min="0" :precision="3" style="width:100%" /></template>
          <template slot="damage" slot-scope="text, record"><a-input-number v-model="record.qtyDamage" :min="0" :precision="3" style="width:100%" /></template>
          <template slot="short" slot-scope="text, record"><a-input-number v-model="record.qtyShort" :min="0" :precision="3" style="width:100%" /></template>
          <template slot="check" slot-scope="text, record">{{ lineOk(record) ? '通过' : '不平' }}</template>
        </a-table>
        <a-row :gutter="12" style="margin-top:12px">
          <a-col :span="4">配送总数 <b>{{ qtyText(sum('deliveryQty')) }}</b></a-col>
          <a-col :span="4">正常签收 <b>{{ qtyText(sum('qtyOk')) }}</b></a-col>
          <a-col :span="4">拒收 <b>{{ qtyText(sum('qtyReject')) }}</b></a-col>
          <a-col :span="4">破损 <b>{{ qtyText(sum('qtyDamage')) }}</b></a-col>
          <a-col :span="4">短少 <b>{{ qtyText(sum('qtyShort')) }}</b></a-col>
        </a-row>
        <div v-if="editing" style="margin-top:16px;text-align:right">
          <a-button style="margin-right:8px" @click="visible = false">取消</a-button>
          <a-button type="primary" :loading="saving" @click="submit">确认签收</a-button>
        </div>
      </template>
    </a-drawer>
  </page-header-wrapper>
</template>

<script>
import { confirmDeliverySign, getDeliverySign, pageDeliverySign } from '@/api/erp/deliveryDispatch'

function qtyText (value) {
  if (value === null || value === undefined || value === '') return '—'
  const number = Number(value)
  return Number.isNaN(number) ? value : String(number)
}

export default {
  name: 'ErpDeliverySign',
  data () {
    return {
      loading: false,
      saving: false,
      rows: [],
      visible: false,
      editing: false,
      detail: null,
      signerName: '',
      query: { keyword: '', status: undefined },
      pagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true, showTotal: total => `共 ${total} 条` },
      columns: [
        { title: '签收单号', dataIndex: 'signNo', width: 180, scopedSlots: { customRender: 'signNo' } },
        { title: '配送任务', dataIndex: 'taskNo', width: 170 },
        { title: '发货单号', dataIndex: 'shipNo', width: 160 },
        { title: '来源类型', dataIndex: 'sourceTypeName', width: 110 },
        { title: '收货方', dataIndex: 'receiverName', width: 150 },
        { title: '配送数量', dataIndex: 'deliveryQty', width: 100, scopedSlots: { customRender: 'qty' } },
        { title: '正常签收', dataIndex: 'qtyOk', width: 100, scopedSlots: { customRender: 'qty' } },
        { title: '拒收', dataIndex: 'qtyReject', width: 80, scopedSlots: { customRender: 'qty' } },
        { title: '破损', dataIndex: 'qtyDamage', width: 80, scopedSlots: { customRender: 'qty' } },
        { title: '短少', dataIndex: 'qtyShort', width: 80, scopedSlots: { customRender: 'qty' } },
        { title: '签收时间', dataIndex: 'signTime', width: 170, scopedSlots: { customRender: 'time' } },
        { title: '状态', dataIndex: 'statusName', width: 90 },
        { title: '操作', dataIndex: 'operation', width: 160, fixed: 'right', scopedSlots: { customRender: 'operation' } }
      ],
      viewColumns: [
        { title: 'SKU', dataIndex: 'skuCode', width: 140 },
        { title: '商品名称', dataIndex: 'skuName' },
        { title: '配送数量', dataIndex: 'deliveryQty', width: 100, scopedSlots: { customRender: 'qty' } },
        { title: '正常签收', dataIndex: 'qtyOk', width: 100, scopedSlots: { customRender: 'qty' } },
        { title: '拒收', dataIndex: 'qtyReject', width: 80, scopedSlots: { customRender: 'qty' } },
        { title: '破损', dataIndex: 'qtyDamage', width: 80, scopedSlots: { customRender: 'qty' } },
        { title: '短少', dataIndex: 'qtyShort', width: 80, scopedSlots: { customRender: 'qty' } },
        { title: '行校验', width: 80, scopedSlots: { customRender: 'check' } }
      ],
      editColumns: [
        { title: 'SKU', dataIndex: 'skuCode', width: 140 },
        { title: '商品名称', dataIndex: 'skuName' },
        { title: '配送数量', dataIndex: 'deliveryQty', width: 100, scopedSlots: { customRender: 'qty' } },
        { title: '正常签收', width: 120, scopedSlots: { customRender: 'ok' } },
        { title: '拒收', width: 110, scopedSlots: { customRender: 'reject' } },
        { title: '破损', width: 110, scopedSlots: { customRender: 'damage' } },
        { title: '短少', width: 110, scopedSlots: { customRender: 'short' } },
        { title: '行校验', width: 80, scopedSlots: { customRender: 'check' } }
      ]
    }
  },
  created () { this.load() },
  methods: {
    qtyText,
    load () {
      this.loading = true
      pageDeliverySign({
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        keyword: this.query.keyword,
        status: this.query.status
      }).then(res => {
        const page = res.data || {}
        this.rows = page.records || []
        this.pagination.total = Number(page.total || 0)
      }).finally(() => { this.loading = false })
    },
    search () { this.pagination.current = 1; this.load() },
    reset () { this.query = { keyword: '', status: undefined }; this.search() },
    onTableChange (pager) {
      this.pagination.current = pager.current
      this.pagination.pageSize = pager.pageSize
      this.load()
    },
    openDetail (record, editing) {
      getDeliverySign(record.id).then(res => {
        const detail = res.data || { items: [] }
        detail.items = (detail.items || []).map(item => ({
          ...item,
          qtyOk: editing && Number(item.qtyOk || 0) === 0 && Number(item.qtyReject || 0) === 0 ? Number(item.deliveryQty || 0) : Number(item.qtyOk || 0),
          qtyReject: Number(item.qtyReject || 0),
          qtyDamage: Number(item.qtyDamage || 0),
          qtyShort: Number(item.qtyShort || 0)
        }))
        this.detail = detail
        this.signerName = detail.signerName || ''
        this.editing = editing
        this.visible = true
      })
    },
    lineOk (record) {
      const sum = Number(record.qtyOk || 0) + Number(record.qtyReject || 0) + Number(record.qtyDamage || 0) + Number(record.qtyShort || 0)
      return Math.abs(sum - Number(record.deliveryQty || 0)) < 0.0001
    },
    sum (field) {
      return (this.detail.items || []).reduce((total, item) => total + Number(item[field] || 0), 0)
    },
    submit () {
      if (!this.signerName) {
        this.$message.warning('请填写签收人')
        return
      }
      if ((this.detail.items || []).some(item => !this.lineOk(item))) {
        this.$message.warning('每一行的正常签收、拒收、破损、短少之和必须等于配送数量')
        return
      }
      this.saving = true
      confirmDeliverySign({
        id: this.detail.id,
        signerName: this.signerName,
        lines: this.detail.items.map(item => ({
          id: item.id,
          qtyOk: item.qtyOk,
          qtyReject: item.qtyReject,
          qtyDamage: item.qtyDamage,
          qtyShort: item.qtyShort
        }))
      }).then(() => {
        this.$message.success('签收完成')
        this.visible = false
        this.load()
      }).finally(() => { this.saving = false })
    }
  }
}
</script>
